import * as React from 'react';
import { MainArea } from './mainArea';
import { MainModel } from './../Models/mainModel';
import { loadContactsPage, SubmitRequest } from './../Actions/contactsActions';
import { HeaderImageComponent } from './headerImage';
import * as renderHTML from 'react-render-html';
import { Field } from 'redux-form';
import { required, email } from './Validations'
import Text from './../Fields/textbox';
import Textarea from './../Fields/textarea';
import {SubmitRequestModel} from "../Models/contactsModel";


declare function require(path: string);
declare var $;
declare var google: any;

//export interface LayoutProps {
//    children?: React.ReactNode;
//}
export class Contacts extends React.Component<MainModel, MainModel> {

    public componentDidMount() {
        this.props.dispatch(loadContactsPage());
        this.loadMap();
    }

    private IsFirstTimeRendered: boolean = false;

    public loadMap() {
        let interval = setInterval(() => {

            if (this.IsFirstTimeRendered)
            {
                clearInterval(interval);
                var loc = { lat: 34.178454, lng: -118.295119 };
                // The map, centered at Uluru
                var map = new google.maps.Map(
                    document.getElementById('map'), { zoom: 15, center: loc });
                // The marker, positioned at Uluru
                var marker = new google.maps.Marker({ position: loc, map: map, label: "Flex Software Corp", title: "Flex Software Corp" });


            }
        }, 500);
    }

    public submitForm(formValues) {

        let model: SubmitRequestModel = new SubmitRequestModel();
        model.Email = formValues.Email;
        model.YourName = formValues.YourName;
        model.Subject = formValues.Subject;
        model.Message = formValues.Message;

        this.props.dispatch(SubmitRequest(model));
    }

    private SetContext(e) {
        e.preventDefault();
        window["contactsContext"] = this;
        let result = this.props.handleSubmit((formValues) => {
            this.submitForm(formValues);
        })();
        return false;
    }

    public render() {

    this.IsFirstTimeRendered = true;
        return this.props.ContactsModel == null ?
            <div className="main-loading-bg" ></div> :
            <div>
                <HeaderImageComponent Image={this.props.ContactsModel.HeaderImage == null ? null : this.props.ContactsModel.HeaderImage.Image} TitleText={this.props.ContactsModel.HeaderImage == null ? null : this.props.ContactsModel.HeaderImage.TitleText} PageGroupID={this.props.ContactsModel.PageGroupID} />
                <section className="setupArea">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12 home-content">
                                {this.props.ContactsModel.HeaderText}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                Tel:&nbsp;&nbsp; <strong>{this.props.MasterModel.PhoneNumber}</strong>  <br />
                                Email:&nbsp;&nbsp; <strong><a href={"mailto:" + this.props.MasterModel.EmailAddress}>{this.props.MasterModel.EmailAddress}</a></strong> <br />
                                Address:&nbsp;&nbsp; <strong>{renderHTML(this.props.MasterModel.CompanyAddressShortText1)}</strong> <br /><br />
                                <div className="row">
                                    <div className="col-xs-6">
                                        <div id="map"></div>
                                        <br /><br />
                                    </div>
                                    <div className="col-xs-6">
                                        <h2>Submit Request</h2>
                                        <form onSubmit={ (e) => { return this.SetContext(e); } } method="POST">
                                            <div className="row" >
                                                <div className="col-md-6 col-sm-12">
                                                    {
                                                        this.props.ContactsModel.SubmitRequestSuccessMessage != null ||
                                                        this.props.ContactsModel.SubmitRequestErrorMessage != null ?
                                                        <div className="row" style={{ marginBottom: 15 }} >
                                                                <div className="col-xs-12" >
                                                                    <span className="success"><strong>{renderHTML(this.props.ContactsModel.SubmitRequestSuccessMessage != null ? this.props.ContactsModel.SubmitRequestSuccessMessage : "" )}</strong></span>
                                                                    <span className="error" ><strong>{renderHTML(this.props.ContactsModel.SubmitRequestErrorMessage != null ? this.props.ContactsModel.SubmitRequestErrorMessage : "")}</strong></span>
                                                            </div>
                                                        </div> : ""
                                                    }

                                                    <div className="row" style={{marginBottom: 15}} >
                                                        <div className="col-xs-12" >
                                                            <Field name="YourName"
                                                                   label="Your Name *"
                                                                   component={Text}
                                                                   className="form-control"
                                                                   placeholder="Enter Your Name..."
                                                                   validate={[required]}
                                                                   type="text" />
                                                        </div>
                                                    </div>
                                                    <div className="row" style={{marginBottom: 15}} >
                                                        <div className="col-xs-12" >
                                                            <Field name="Email"
                                                                   label="Email *"
                                                                   component={Text}
                                                                   className="form-control"
                                                                   placeholder="Email..."
                                                                   validate={[required, email]}
                                                                   type="text" />
                                                        </div>
                                                    </div>
                                                    <div className="row" style={{marginBottom: 15}} >
                                                    <div className="col-xs-12" >
                                                        <Field name="Subject"
                                                               label="Subject *"
                                                               component={Text}
                                                               className="form-control"
                                                               placeholder="Subject..."
                                                               validate={[required]}
                                                               type="text" />
                                                    </div>
                                                </div>
                                                    <div className="row" style={{marginBottom: 15}} >
                                                        <div className="col-xs-12" >
                                                            <Field name="Message"
                                                                   label="Message *"
                                                                   component={Textarea}
                                                                   className="form-control"
                                                                   placeholder="Message..."
                                                                   validate={[required]}
                                                                   type="text" />
                                                        </div>
                                                    </div>
                                                    <div className="row" style={{marginBottom: 15}} >
                                                        <div className="col-xs-12" >
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary pull-right"
                                                            >
                                                                Submit
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                             </div>

                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>;
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/Components/contacts.tsx